import { render, staticRenderFns } from "./PcProfileApplicationsTab.vue?vue&type=template&id=438b1d9a"
import script from "./PcProfileApplicationsTab.vue?vue&type=script&lang=js"
export * from "./PcProfileApplicationsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports